import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../../modules/api/client";
import { PromoAdminItem } from "./types";
import cls from "./PromoAdmin.module.scss";

type PromoListResponse = {
    items: PromoAdminItem[];
    limit?: number;
    offset?: number;
    count?: number;
};

const PromoList: React.FC = () => {
    const [items, setItems] = useState<PromoAdminItem[]>([]);
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState<string | null>(null);
    const nav = useNavigate();

    const load = async () => {
        setLoading(true); setErr(null);
        try {
            const data = await api.get<PromoListResponse | PromoAdminItem[]>("/admin/promos");
            const list = Array.isArray(data) ? data : data?.items;
            setItems(Array.isArray(list) ? list : []);
        } catch (e: any) {
            setErr(e?.message || "Ошибка загрузки");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { load(); }, []);

    const onDelete = async (id: number) => {
        if (!window.confirm("Удалить акцию?")) return;
        try {
            await api.delete(`/admin/promos/${id}`);
            setItems(prev => prev.filter(i => i.id !== id));
        } catch (e: any) {
            alert(e?.message || "Не удалось удалить");
        }
    };

    // Перетаскивание для веса
    const [dragId, setDragId] = useState<number | null>(null);
    const onDragStart = (id: number) => setDragId(id);
    const onDragOver = (e: React.DragEvent, overId: number) => {
        e.preventDefault();
        if (dragId === null || dragId === overId) return;
        setItems(prev => {
            const list = [...prev];
            const from = list.findIndex(i => i.id === dragId);
            const to = list.findIndex(i => i.id === overId);
            if (from < 0 || to < 0) return prev;
            const [moved] = list.splice(from, 1);
            list.splice(to, 0, moved);
            return list;
        });
    };
    const onDrop = async () => {
        setDragId(null);
        const order = items.map((it, idx) => ({ id: it.id, weight: (idx + 1) * 10 }));
        setItems(prev => prev.map((it, idx) => ({ ...it, weight: (idx + 1) * 10 })));
        try {
            await api.post("/admin/promos/reorder", { order });
        } catch (e: any) {
            alert(e?.message || "Не удалось сохранить порядок");
            load();
        }
    };

    return (
        <div className={cls.card}>
            <div className={cls.header}>
                <h2 style={{ margin:0 }}>Акции</h2>
                <div className={cls.toolbar}>
                    <span className={cls.dragHint}>Перетащите строки для изменения порядка</span>
                    <Link className={cls.btn} to="/admin/promos/new">+ Создать</Link>
                </div>
            </div>

            {loading ? "Загрузка…" : err ? <div style={{ color: "crimson" }}>{err}</div> : (
                <table className={cls.table}>
                    <thead>
                    <tr>
                        <th style={{ width:32 }}></th>
                        <th>ID</th>
                        <th>Карточка</th>
                        <th>Деталка</th>
                        <th>Вес</th>
                        <th>Период</th>
                        <th>Активна</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    {items.map(n => (
                        <tr key={n.id}
                            draggable
                            onDragStart={() => onDragStart(n.id)}
                            onDragOver={(e) => onDragOver(e, n.id)}
                            onDrop={onDrop}
                        >
                            <td className={cls.handle}>⋮⋮</td>
                            <td>{n.id}</td>
                            <td>
                                <div className={cls.preview} style={{ backgroundImage:`url('${n.cardImage}')` }} />
                            </td>
                            <td>
                                <div className={cls.preview} style={{ backgroundImage:`url('${n.modalImage}')` }} />
                            </td>
                            <td>{n.weight}</td>
                            <td>
                                <div>{n.startsAt || "—"} → {n.endsAt || "—"}</div>
                            </td>
                            <td><span className={cls.badge}>{n.active ? "Да" : "Нет"}</span></td>
                            <td style={{ textAlign:"right", whiteSpace:"nowrap" }}>
                                <button className={`${cls.btn} ${cls.ghost}`} onClick={() => nav(`/admin/promos/${n.id}`)} style={{ marginRight: 8 }}>
                                    Редактировать
                                </button>
                                <button className={`${cls.btn} ${cls.red}`} onClick={() => onDelete(n.id)}>
                                    Удалить
                                </button>
                            </td>
                        </tr>
                    ))}
                    {items.length === 0 && (
                        <tr><td colSpan={8} style={{ opacity:.7, padding:12 }}>Пока нет акций</td></tr>
                    )}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default PromoList;
